import { ActionType, createAction } from 'typesafe-actions'
import { Geografi, isGeografi, Parti } from '../../domain'

export const setGeografi = createAction('page/SET_GEOGRAFI', action => {
  return (geografi: Geografi) => action(geografi)
})

export const setParti = createAction('page/SET_PARTI', action => {
  return (parti: Parti) => action(parti)
})

export const setPageNotFound = createAction('page/SET_PAGE_NOT_FOUND', action => {
  return () => action()
})

// Workaround. Need an action creator with no parameters to avoid type errors
export const blank = createAction('blank', action => {
  return () => action()
})

export function setPage(grunndata: Geografi | Parti) {
  return async (dispatch, getState) => {
    if (isGeografi(grunndata)) {
      return dispatch(setGeografi(grunndata))
    } else {
      return dispatch(setParti(grunndata))
    }
  }
}

export type PageAction =
  | ActionType<typeof setGeografi>
  | ActionType<typeof setParti>
  | ActionType<typeof setPageNotFound>
  | ActionType<typeof blank>
